// Estilos para el componente ActaForm
const styles = {
  container: {
    maxWidth: 'auto',
    mx: 'auto'
  },
  paper: {
    borderRadius: 1,
    overflow: 'hidden'
  },
  header: {
    p: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: 'white'
  },
  title: {
    fontWeight: 'bold',
    color: '#1f2937',
    fontSize: '1.5rem',
    width: '14vw'
  },
  progressContainer: {
    px: 2,
    pb: 2
  },
  progressBar: {
    height: 8,
    borderRadius: 4,
    background: '#e5e7eb',
    '& .MuiLinearProgress-bar': {
      background: '#696cff'
    }
  },
  formContent: {
    p: 3
  },
  sectionTitle: {
    mb: 2
  },
  sectionContainer: {
    mb: 4,
    border: '1px solid #d1d5db',
    p: 2,
    borderRadius: 1
  },
  divider: {
    my: 3
  },
  tableContainer: {
    mt: 2,
    mb: 3,
    border: '1px solid rgba(224, 224, 224, 1)',
    borderRadius: 1
  },
  tableHeader: {
    bgcolor: '#f5f5f5'
  },
  addButton: {
    mt: 1
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 2,
    mt: 3
  },
  submitButton: {
    bgcolor: '#4472c4',
    '&:hover': {
      bgcolor: '#365b9d'
    }
  },
  previewButton: {
    color: '#4472c4',
    borderColor: '#4472c4'
  },
  cancelButton: {
    color: 'inherit'
  },
  commitmentSection: {
    mt: 3
  },
  previousCommitments: {
    mt: 2,
    p: 2,
    bgcolor: '#f8f9fa',
    borderRadius: 1
  },
  loadingIndicator: {
    display: 'flex',
    justifyContent: 'center',
    my: 2
  },
  errorMessage: {
    mt: 1,
    color: 'error.main'
  },
  infoChip: {
    mt: 1
  },
  previousOrdenDia: {
    bgcolor: '#e7e7ff',
    borderRadius: 1,
    p: 2,
    mb: 2
  },
  previousOrdenDiaTitle: {
    mb: 2,
    fontWeight: 500
  },
  autoGrowTextField: {
    '& .MuiOutlinedInput-root': {
      height: 'auto',
      minHeight: '100px',
      transition: 'all 0.2s ease',
      '& textarea': {
        height: '100% !important',
        resize: 'none',
        overflow: 'hidden',
        '&::-webkit-scrollbar': {
          display: 'none'
        }
      }
    }
  }
};

export default styles;